import { enableProdMode } from '@angular/core';

import { bootstrapModule } from '@priva/microfrontends/shared';
import { PrivaPreloaderElement } from '@priva/preloader';

import { AppModule } from 'app/app.module';

import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapModule(AppModule, { appType: 'host', production: environment.production })
    .then(() => {
        document.querySelector<PrivaPreloaderElement>('priva-preloader')?.appBootstrap();
    })
    .catch((err) => console.log(err));
